import { Divider } from '@@/Divider/Divider';

export function TimelineDivider() {
  return <Divider className="!ml-3" orientation="vertical" length="60%" />;
}
